import React, { useState, useRef, useEffect } from 'react';

import * as S from './styles';
import { H6 } from '../../styles/stylesTypography';

import IconUpBlack from '../../assets/icons/icon-arrow-down-alone-gray.png';

const AcordionCard = ({
  title,
  children,
  isOpen,
  height,
  hasError,
  Padding,
  hasBlock = false,
  hideToggleIcon = false,
  onToggle,
  accordionKey,
  showContentAcordionClose,
  contentAcordionClose,
  maxWidth,
  maxWidthAcordionHeader,
  titleColor
}) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(isOpen);
  const contentRef = useRef(null);

  useEffect(() => {
    setIsAccordionOpen(isOpen);
  }, [isOpen]);

  const toggleAccordion = () => {
    if (!hasBlock) {
      setIsAccordionOpen(!isAccordionOpen);
      if (onToggle) {
        onToggle(accordionKey);
      }
    }
  };

  return (
    <S.ContainerAcordionCard>
      <S.Acordion isOpen={isAccordionOpen} hasError={hasError} Padding={Padding} hasBlock={hasBlock} hideToggleIcon={hideToggleIcon} maxWidthAcordion={maxWidth}>
        <S.AcordionHeader
          onClick={toggleAccordion}
          isOpen={isAccordionOpen}
          Padding={Padding}
          hasBlock={hasBlock}
          hideToggleIcon={hideToggleIcon}
          maxWidthAcordionHeader={maxWidthAcordionHeader}
          titleColor={titleColor}
        >
          <H6>
            {title}
          </H6>

          {!hideToggleIcon && (
            <S.ArrowIcon
              src={IconUpBlack}
              alt={isAccordionOpen ? 'Fechar accordion' : 'Abrir accordion'}
              $isOpen={isAccordionOpen}
            />
          )}
        </S.AcordionHeader>

        {!isAccordionOpen && showContentAcordionClose && contentAcordionClose ? contentAcordionClose : null}

        <S.AcordionContent
          ref={contentRef}
          $isOpen={isAccordionOpen}
        >
          <S.ContentWrapper>{children}</S.ContentWrapper>
        </S.AcordionContent>
      </S.Acordion>
    </S.ContainerAcordionCard>
  );
};

export default AcordionCard;
